import { lazy } from "react";

const BrokerAdminDashboard = lazy(() =>
  import("../Views/BrokerAdmin/Dashboard/dashboard")
);
const BrokersTab = lazy(() => import("../Views/BrokerAdmin/Brokers/Broker"));
const ClientsTab = lazy(() => import("../Views/BrokerAdmin/Clients/Clients"));
const MemberManagementAdmin = lazy(() =>
  import("../Views/BrokerAdmin/Members/MemberManagementAdmin")
);

const broker_admin = [
  {
    path: "/broker-admin/dashboard",
    exact: true,
    name: "Broker Dashboard",
    component: BrokerAdminDashboard,
  },
  {
    path: "/member-management-masterclient",
    exact: true,
    name: "Member Management",
    component: MemberManagementAdmin,
  },
  {
    path: "/broker-admin/user",
    exact: true,
    name: "User",
    component: BrokersTab,
  },
  {
    path: "/broker-admin/client",
    exact: true,
    name: "Client",
    component: ClientsTab,
  },
];

export default broker_admin;
